import { HTMLAttributes } from 'react'
import { BgColors } from 'types'

import { twMerge } from 'tailwind-merge'

interface PageProps extends HTMLAttributes<HTMLDivElement> {
    readonly background?: BgColors
}

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

function Page({
    background = 'bg-white',
    className,
    children,
    ...props
}: PageProps): JSX.Element {
    return (
        <div
            {...props}
            className={twMerge(
                'min-h-[100dvh] flex flex-col items-center justify-center',
                'text-[calc(10px_+_2vmin)]',
                'text-primary',
                background,
                className
            )}
        >
            {children}
        </div>
    )
}

function Container({
    className,
    children,
    ...props
}: ContainerProps): JSX.Element {
    return (
        <div
            {...props}
            className={twMerge(
                'overflow-hidden relative flex flex-col rounded-md mx-auto my-0 w-[30rem] min-h-[37.5rem] bg-white shadow-lg sm:flex-1 sm:w-full sm:rounded-none',
                className
            )}
        >
            {children}
        </div>
    )
}

Page.Container = Container

export { Page }
